// T Santosh Kumar 24/03/2023 3225736869 Added the Icon
// Prakash 04/06/2023 3225736869 remove margin top and fixed button issue
// Akhila 04/19/2023 3225736869  table reusable in account summary
// Guru Prasad 04/20/2023 3225736869  Fixed Phone Details table alignments
// Akhila 06/05/2023 3225736869 bug fix preppropulation issue in account summary
// Ravi 06/22/2023 3225736869 fixed submit issue
// uday 03/010/2023 3225736869 bug ui fix issue in account summary
// Gireesh 13/10/2023 5155351118 fixed table rows drag and drop issue

// uday 16/10/2023 3225736869 add condtion classname table alignments issues
// uday 06/12/2023 3225736869 add condtion classname table alignments issues
// Sohel 07/12/2023 5155351118 Fixed Client Management Reset Issue
import React, {useEffect, useMemo, useState} from 'react';
import {Button, Grid, makeStyles, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import reusableInputStyles from '../../../components/InputStyles';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {useDispatch, useSelector} from 'react-redux';
import DialogBox from '../../../components/DialogBox';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  getEditContactPhoneDetails,
  getPhonesDetails,
  postPhonesListData,
  resetEditTableData,
  fetchPhoneData,
  resetClientInfo,
} from '../../../redux/reducers/clientMangement/Organizaation';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddIcon from '@material-ui/icons/AddOutlined';
import PhoneForm from './PhoneForm';
import {MTableBody, MTableBodyRow} from 'material-table';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'flex',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
      textAlign: 'center',
    },
    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
  },
});
export default function searchTable({
  id,
  orgType,
  AccountSummary,
  clientInfoData,
  clientNumber,
  organizationAccess,
}) {
  const {errorMsg, successMsg, phonesData, editContactPhoneData, phoneTableData} = useSelector(
    ({organization}) => organization,
  );
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);
  const [open, setOpen] = useState(false);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const getApiData = useMemo(() => {
    if (phoneTableData && phoneTableData.length > 0) {
      return phoneTableData?.map((item) => ({...item}));
    }
    return [];
  }, [phoneTableData]);

  useEffect(() => {
    if (getApiData?.length > 0) {
      const data = [...getApiData];
      data?.sort((a, b) => a['seqNo'] - b['seqNo']);
      const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
      setSelectedRows(newData);
    } else if (phonesData?.length > 0) {
      const data = [...phonesData];
      data?.sort((a, b) => a['seqNo'] - b['seqNo']);
      const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
      setSelectedRows(newData);
    } else {
      setSelectedRows([])
    }
  }, [getApiData, phonesData]);

  const handleClose = () => {
    setOpen(false);
    dispatch(resetEditTableData());
  };
  useEffect(() => {
    if (AccountSummary && clientNumber) {
      dispatch(fetchPhoneData(clientNumber));
    }
  }, [AccountSummary, clientNumber]);
  useEffect(() => {
    if (successMsg) {
      dispatch(getPhonesDetails(id, orgType));
      handleClose();
      dispatch(resetClientInfo());
    }
  }, [successMsg]);

  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      // headerStyle: { textAlign: 'left', marginLeft: '5px', },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        if (selectedRows?.length > 0) {
          selectedRows[rowData?.tableData?.id].seqNo = rowSeqNo;
        }
        return (
          <div className={ AccountSummary
            ? `account-seqno`:`seqno-client`}
          >
            {rowSeqNo}
          </div>
        );
      },
    },
    {
      title: 'Phone Number',
      field: 'phoneNumber',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 130,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '8px',
            }}
          >
            {rowData?.phoneNumber ? rowData?.phoneNumber : '-'}
          </div>
        </>
      ),
    },
    {
      title: 'Phone Type',
      field: 'phoneType',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 130,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '8px',
            }}
          >
            {rowData?.phoneType ? rowData?.phoneType : '-'}
          </div>
        </>
      ),
    },
    {
      title: 'Opt In',
      field: 'optInFlag',
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 130,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              paddingLeft: '8px',
            }}
          >
            {rowData?.optInFlag ? rowData?.optInFlag : '-'}
          </div>
        </>
      ),
    },
  ];

  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...selectedRows];
      const temp = selectedRows[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setSelectedRows(copyRows);
    }
  };

  return (
    <div className="mt-3">
      <DialogBox
        open={open}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'lg'}
        title={editContactPhoneData?.orgPhoneId ? 'Edit Phone Details' : `Add Phone Details`}
      >
        <PhoneForm handleClose={handleClose} id={id} type={orgType} selectedRows={selectedRows} />
      </DialogBox>
      <Grid item xs={12} className="">
        <div
          className={AccountSummary ? `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec new-standard-textfields`: 
          `mb-4 global-field-table custom-table ${classes1.letterTable} drag-and-drop-table custom-map-sec drawdrag-table   new-standard-textfields `}
        >
          <GuiTable
            title={`Phone Details`}
            columns={columns}
            icons={tableIcons}
            data={
              selectedRows.length > 0 ?
                selectedRows?.map((item) => ({...item})) :
                getApiData ?
                  getApiData :
                  []
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'right',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              !AccountSummary && [
                {
                  icon: () => (
                    <>
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        startIcon={<AddIcon />}
                        disabled={!organizationAccess?.edit}
                      >
                        Add Phone Details
                      </Button>
                    </>
                  ),
                  disabled: !organizationAccess?.edit,
                  isFreeAction: true,
                  onClick: (event) => {
                    setOpen(true);
                  },
                },
                {
                  icon: () => <EditOutlinedIcon />,
                  tooltip: 'Edit',
                  disabled: !organizationAccess?.edit,
                  onClick: (event, rowData) => {
                    dispatch(getEditContactPhoneDetails(rowData?.orgPhoneId));
                    setOpen(true);
                  },
                },
              ]
            }
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
              Body: (props) => (
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                      {(provided) => (
                        <div ref={provided.innerRef}>
                          <MTableBody {...props} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              ),
              Row: (props) => (
                <Draggable
                  draggableId={props.data.tableData.id.toString()}
                  index={props.data.tableData.id}
                >
                  {(provided) => (
                    <div
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                    >
                      <MTableBodyRow {...props} />
                    </div>
                  )}
                </Draggable>
              ),
            }}
          />
        </div>
      </Grid>
      <div className="button-spacing-mb  new-standard-textfields">
        <Button
          variant="outlined"
          className={`reset-btn mr-1 ${classes.buttonRoot}`}
          hidden={AccountSummary}
          onClick={() => {
            const data = [...phonesData];
            data?.sort((a, b) => a['seqNo'] - b['seqNo']);
            const newData = data.map((item, i) => ({...item, seqNo: i + 1}));
            setSelectedRows(newData);
          }}
        >
          Reset
        </Button>
        <Button
          variant="outlined"
          type="button"
          hidden={AccountSummary}
          disabled={!organizationAccess?.edit || enabledSubmission}
          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
          onClick={() => {
            dispatch(submissionStart());
            dispatch(postPhonesListData({organizationPhoneListRequest: selectedRows}));
          }}
        >
          Save
        </Button>
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
